/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Asi_Statement_TextInputs */

const en_home_quotes_asi_statement_text = /** @type {(inputs: Home_Quotes_Asi_Statement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We call for a prohibition on the development of superintelligence, not lifted before there is broad scientific consensus that it will be done safely and controllably, and strong public buy-in`)
};

/**
* | output |
* | --- |
* | "We call for a prohibition on the development of superintelligence, not lifted before there is broad scientific consensus that it will be done safely and cont..." |
*
* @param {Home_Quotes_Asi_Statement_TextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_asi_statement_text = /** @type {((inputs?: Home_Quotes_Asi_Statement_TextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Asi_Statement_TextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_asi_statement_text(inputs)
});